import React from "react";
import { Table } from "reactstrap";
import Loader from "../Loader/Loader";
import {
  FilaSeguimientoTNP,
  FilaDatosPersonalesTNP,
  FilaVaciaTNP,
} from "./FilaProspectoTNP";

/**
 * Tabla de Seguimiento TNP
 */
export const TablaSeguimientoTNP = ({
  prospectos,
  instituciones,
  estado,
  loading,
  asignacionActiva,
  prospectosSeleccionados,
  onSelectAll,
  onCheckboxChange,
  detalleCreditoFallido,
  user,
}) => {
  const allChecked = prospectosSeleccionados.length === prospectos.length && prospectos.length > 0;

  return (
    <div className="table-container" style={{ position: 'relative', minHeight: '400px' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          top: '50px',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10
        }}>
          <Loader />
        </div>
      )}
      <Table hover size="sm">
        <thead>
          <tr>
            {asignacionActiva && (
              <th>
                ASIGNAR
                <br />
                <input type="checkbox" onChange={onSelectAll} checked={allChecked} />
              </th>
            )}
            <th className="prospecto-dni">DNI</th>
            <th className="prospecto-nombre">Apellidos y Nombres</th>
            <th className="prospecto-celular">Celulares</th>
            <th className="prospecto-convenio">Convenio</th>
            <th>Contactado</th>
            <th>Estado</th>
            <th>Observación</th>
            {(Number(user?.perfil_id) === 6 || Number(user?.perfil_id) === 8) && (
              <th style={{ minWidth: '140px' }}>Colaborador</th>
            )}
          </tr>
        </thead>
        <tbody style={{ opacity: loading ? 0.3 : 1 }}>
          {prospectos.length > 0 ? (
            prospectos.map((prospecto, index) => (
              <FilaSeguimientoTNP
                key={prospecto.prospecto_id}
                prospecto={prospecto}
                instituciones={instituciones}
                estado={estado}
                mostrarCheckbox={asignacionActiva}
                onCheckboxChange={onCheckboxChange}
                isChecked={prospectosSeleccionados.includes(prospecto.prospecto_id)}
                detalleCreditoFallido={detalleCreditoFallido}
                user={user}
                isLastRows={prospectos.length > 5 && index >= prospectos.length - 2}
              />
            ))
          ) : (
            <FilaVaciaTNP colSpan={
              7 
              + (asignacionActiva ? 1 : 0) 
              + ((Number(user?.perfil_id) === 6 || Number(user?.perfil_id) === 8) ? 1 : 0)
            } />
          )}
        </tbody>
      </Table>
    </div>
  );
};

/**
 * Tabla de Datos Personales TNP
 */
export const TablaDatosPersonalesTNP = ({
  prospectos,
  estadoCivil,
  contratoCondicion,
  formatoSoles,
  loading,
}) => {
  return (
    <div className="table-container" style={{ position: 'relative', minHeight: '400px' }}>
      {loading && (
        <div style={{
          position: 'absolute',
          top: '50px',
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 10
        }}>
          <Loader />
        </div>
      )}
      <Table hover size="sm">
        <thead>
          <tr>
            <th rowSpan="2" className="prospecto-dni">DNI</th>
            <th rowSpan="2" className="prospecto-nombre">Apellidos y Nombres</th>
            <th rowSpan="2">Email</th>
            <th colSpan="5">Información Personal</th>
            <th colSpan="3">Información Laboral</th>
          </tr>
          <tr>
            <th>Edad</th>
            <th>Estado Civil</th>
            <th className="prospecto-direccion">Dirección</th>
            <th>Cons. Datos</th>
            <th>DNI Cónyuge</th>
            <th className="prospecto-cargo">Cargo</th>
            <th>Condición Laboral</th>
            <th>Rango de Ingresos</th>
          </tr>
        </thead>
        <tbody style={{ opacity: loading ? 0.3 : 1 }}>
          {prospectos.length > 0 ? (
            prospectos.map((prospecto) => (
              <FilaDatosPersonalesTNP
                key={prospecto.prospecto_id}
                prospecto={prospecto}
                estadoCivil={estadoCivil}
                contratoCondicion={contratoCondicion}
                formatoSoles={formatoSoles}
              />
            ))
          ) : (
            <FilaVaciaTNP colSpan="11" />
          )}
        </tbody>
      </Table>
    </div>
  );
};
